module.exports = __webpack_public_path__ + "img/icon.f9c38e4e.svg";